import { fromJS } from 'immutable';
import {
  DECRYPT_URL_REQUEST,
  DECRYPT_URL_SUCCESS,
  DECRYPT_URL_FAILURE,
  FETCH_HTML_REQUEST,
  FETCH_HTML_SUCCESS,
  FETCH_HTML_FAILURE,
  FETCH_TEMPLATE_REQUEST,
  FETCH_TEMPLATE_SUCCESS,
  FETCH_TEMPLATE_FAILURE,
  UPDATE_HTML_REQUEST,
  UPDATE_HTML_SUCCESS,
  UPDATE_HTML_FAILURE
} from './constants';

const initialState = fromJS({
  isDecryptingURL: false,
  isFetchingHTML: false,
  htmlDetail: {},
  isUpdatingHTML: false,
  isFetchingTemplate: false,
  templateString: ''
});

export default (state = initialState, action) => {
  switch (action.type) {
    /** DECRYPT URL */
    case DECRYPT_URL_REQUEST:
      return state.set('isDecryptingURL', true);
    case DECRYPT_URL_SUCCESS:
      return state.set('isDecryptingURL', false);
    case DECRYPT_URL_FAILURE:
      return state.set('isDecryptingURL', false);
    /** FETCH HTML DETAIL */
    case FETCH_HTML_REQUEST:
      return state.set('isFetchingHTML', true);
    case FETCH_HTML_SUCCESS:
      return state.set('isFetchingHTML', false).set('htmlDetail', fromJS(action.html));
    case FETCH_HTML_FAILURE:
      return state.set('isFetchingHTML', false);
    /** UPDATE HTML DETAIL */
    case UPDATE_HTML_REQUEST:
      return state.set('isUpdatingHTML', true);
    case UPDATE_HTML_SUCCESS:
      return state.set('isUpdatingHTML', false);
    case UPDATE_HTML_FAILURE:
      return state.set('isUpdatingHTML', false);
    /** FETCH HTML TEMPLATE */
    case FETCH_TEMPLATE_REQUEST:
      return state.set('isFetchingTemplate', true);
    case FETCH_TEMPLATE_SUCCESS:
      return state.set('isFetchingTemplate', false).set('templateString', action.templateString);
    case FETCH_TEMPLATE_FAILURE:
      return state.set('isFetchingTemplate', false);
    /** DEFAULT */
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/containers/html/reducer.js